<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <DiagnosticListing />
    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import DiagnosticListing from "@/views/pages/admin/diagnostic/diagnosticListing";

export default {
    page: {
        title: i18n.t("module.diagnostics"),
    },
    components: { Layout, PageHeader, DiagnosticListing },
    data() {
        return {
            title: i18n.t("module.diagnostics"),
            items: [
                {
                    text: i18n.t("module.system"),
                    href: '/systems',
                },
                {
                    text: i18n.t("module.diagnostics"),
                    active: true,
                },
            ],
        };
    },
}
</script>
